export { default } from './SkeletonFareCalendarOIMobile';
